import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Attach Bearer token from localStorage as fallback (cookies may be blocked in cross-origin sandbox)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("akm_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    }
    // Structured error object: prefer `message`, then `msg`, then stringify.
    if (detail && typeof detail === "object") {
        if (typeof detail.message === "string") return detail.message;
        if (typeof detail.msg === "string") return detail.msg;
    }
    return String(detail);
}
